import { PersistStorage } from "zustand/middleware";

export const storageWithDateRange: PersistStorage<any> = {
  getItem: (name) => {
    const storedValue = localStorage.getItem(name);
    if (!storedValue) return null;
    const parsed = JSON.parse(storedValue);
    if (parsed.state.dateRange) {
      parsed.state.dateRange.startDate = new Date(
        parsed.state.dateRange.startDate,
      );
      parsed.state.dateRange.endDate = new Date(parsed.state.dateRange.endDate);
    }
    return parsed;
  },
  setItem: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key) => {
    localStorage.removeItem(key);
  },
};
